import { render, staticRenderFns } from "./CameraAndMicrophoneSettings.vue?vue&type=template&id=05e5295a&scoped=true&"
import script from "./CameraAndMicrophoneSettings.vue?vue&type=script&lang=js&"
export * from "./CameraAndMicrophoneSettings.vue?vue&type=script&lang=js&"
import style0 from "./CameraAndMicrophoneSettings.vue?vue&type=style&index=0&id=05e5295a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e5295a",
  null
  
)

export default component.exports